module.exports = __webpack_public_path__ + "img/max-office-building-subtract.1df1faa3.svg";